<template>
  <div>
    <ui-card class="comment-input">
      <ui-avatar :url="authInfo.avatar"></ui-avatar>
      <ui-v ref="comment-form" :rules="rules">
        <ui-textarea
          ref="commentInput"
          name="comment"
          autosize
          counter
          :rows="3"
          :max-length="1000"
          :placeholder="$t('leaveComment')"
          v-model="comment"
        >
        </ui-textarea>
      </ui-v>
      <ui-button
        class="right"
        size="sm"
        :loading="postting"
        type="primary"
        @click.native="post"
        >{{ $t("postComment") }}</ui-button
      >
    </ui-card>
    <ui-loader
      :loading="loading"
      :lang="loaderLang"
      :completed="completed"
      :listens="['scroll']"
      @scroll="scroll"
      :offset="-150"
    >
      <comment-item
        v-for="comment of commentList"
        :key="comment.id"
        :comment="comment"
      ></comment-item>
    </ui-loader>
  </div>
</template>
<script>
import api from "../../api/index";
import { mapGetters } from "vuex";
import CommentItem from "./comment-item.vue";
import Vue from "vue";
export default {
  data() {
    return {
      comment: "",
      postting: false,
      mounted: false,
      commentList: [],
      limit: 10,
      loading: false,
      completed: false,
      loaderLang: {
        pullDownToRefresh: this.$t("pullDownToRefresh"),
        releaseToRefresh: this.$t("releaseToRefresh"),
        pullUpToLoad: this.$t("pullUpToLoad"),
        loadCompleted: this.$t("loadCompleted")
      },
      rules: {
        comment: [
          {
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("comment")
          }
        ]
      }
    };
  },
  props: ["article"],
  components: {
    CommentItem
  },
  computed: {
    ...mapGetters(["authInfo"]),
    skip() {
      return this.commentList.length;
    }
  },
  mounted() {
    this.fetchData();
    this.mounted = true;
  },
  methods: {
    scroll() {
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      this.completed = false;
      api
        .commentList(this.article.id, this.limit, this.skip)
        .then(res => {
          this.loading = false;
          if (res.status == 200) {
            this.commentList = this.commentList.concat(res.data.commentList);
          }
          if (res.status == 204) {
            this.completed = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    post() {
      this.$refs["comment-form"]
        .validate()
        .then(e => {
          this.postting = true;
          let data = {};
          data.aid = this.article.id;
          data.comment = this.comment;
          api
            .publishComment(data)
            .then(res => {
              let comment = res.data.comment;
              this.commentList.unshift(comment);
              this.comment = "";
              this.postting = false;
              this.$refs["commentInput"].resetSize();
            })
            .catch(error => {
              console.log(error);
              this.postting = false;
            });
        })
        .catch(err => {});
      return;
    }
  }
};
</script>
